import { useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../services/api'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await api.post('/auth/forgot-password', { email })
    } catch {}
    setSent(true)
    setLoading(false)
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg)' }}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/logo-mark.svg" alt="HSEQ Intelligence" className="mx-auto mb-4" style={{ width: 72, height: 72 }} />
          <h1 className="text-2xl font-bold" style={{ color: 'var(--text)' }}>Reset your password</h1>
          <p className="text-sm mt-1" style={{ color: 'var(--text-muted)' }}>
            Enter your work email and we'll send a reset link.
          </p>
        </div>

        <div className="card">
          {sent ? (
            <div className="text-center space-y-4 py-2">
              <div className="text-4xl">✉️</div>
              <p className="font-semibold" style={{ color: 'var(--text)' }}>Check your inbox</p>
              <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
                If that email exists, a reset link has been sent. Check your spam folder if it doesn't arrive within a few minutes.
              </p>
              <Link to="/login" className="btn btn-primary w-full justify-center" style={{ display: 'flex' }}>
                Back to login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label>Work email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  placeholder="you@company.com.au"
                />
              </div>
              <button type="submit" className="btn btn-primary w-full justify-center" disabled={loading}>
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
            </form>
          )}

          {!sent && (
            <p className="text-center text-sm mt-4" style={{ color: 'var(--text-muted)' }}>
              Remember it?{' '}
              <Link to="/login" style={{ color: 'var(--accent)' }} className="font-medium">Back to login</Link>
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
